import { render, staticRenderFns } from "./publicar.vue?vue&type=template&id=453ed6b0&"
import script from "./publicar.vue?vue&type=script&lang=js&"
export * from "./publicar.vue?vue&type=script&lang=js&"
import style0 from "./publicar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports